import React, {useState, useEffect} from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Grid,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Toolbar,
  Stack,
  FormGroup,
  Checkbox
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import Logo from 'src/minimal-components/logo';
import AccountPopover from 'src/layouts/common/account-popover';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {
  getSearchForm,
  getLMSResultsData
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {enqueueSnackbar} from 'notistack';
import {
  LMS_TYPE,
  BASE_RECORD_ID,
  BASE_UNIQUE_ID,
  LMS_MODULE_ID,
  LMS_PREVIEW_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  PARAMS_KEY,
  MOVE_TO_TAB,
  LMS_IS_ADMIN,
  BASE_UNIQUE_TYPE
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import {useAppContext} from '@context/AppContext';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {LoadingButton} from '@mui/lab';
import ReviewAttemptDialog from './ReviewAttemptDialog ';
import FormConstants from '@shared/constants/FormConstants';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import MatchTheFollowingQuestion from './MatchPairs';
import {is} from 'date-fns/locale';
import ContextTextField from './ContentText';
import {useModulePreviewContext} from '@context/ModulePreviewContextProvider';
import { environment } from '@shared/config/environment';
interface ModuleData {
  id: string;
  name: string;
  expanded: boolean;
  description?: string;
  duration?: string;
  type: string;
  sequence: number;
  module_lock_type_id?: number;
  locked_until_date?: string;
  Module_Completed?: boolean;
  IsUnlocked?: boolean;
  is_completed?: boolean;
  locked_linked_items?: {
    id: string;
    item_name: string;
    entity_completion_sub_type_id: number;
    module_link_id: any;
    module_id: any;
    type: 'file' | 'link' | 'content' | 'assignment' | 'onlinetest' | 'module';
  }[];
  files?: {
    id: string;
    name: string;
    ParentName: string;
    blob_file_extension?: string;
    fileexpanded: boolean;
    time?: string;
    score?: string;
    lock_type_id: number;
    locked_until_date?: string;
    type: string;
    module_id: any;
    remainingAttempts?: number;
    sequence: number;
    ChildItems_Completed?: boolean;
    IsUnlocked?: boolean;
    is_completed?: boolean;
    additionalFiles?: {id: string; name: string}[];
    locked_linked_items?: {
      id: string;
      item_name: string;
      entity_completion_sub_type_id: number;
      module_link_id: any;
      module_id: any;
      type:
        | 'file'
        | 'link'
        | 'content'
        | 'assignment'
        | 'onlinetest'
        | 'module';
    }[];
  }[];
}
const ExamPage = () => {
  const params: any = useParams();
  const {
    appState: {applicationName}
  } = useAppContext();
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  const [selectedOption, setSelectedOption] = useState<any | null>(null);
  const [timeLeft, setTimeLeft] = useState(0); // 20 minutes in seconds
  const [tabSwitchDetected, setTabSwitchDetected] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [tabTimer, setTabTimer] = useState<NodeJS.Timeout | null>(null); // Allow timeout storage
  const [fileSelected, setFileSelected] = useState<any>(null);
  const [isLoading, setIsloading] = React.useState(false);
  const [open, setOpen] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [selectedOptions, setSelectedOptions] = useState<
    Array<{
      id: any;
      type: number;
      isanswered: boolean;
      answers: string[] | string | boolean | {left: string; right: string}[];
    }>
  >([]);
  // Stores selected answers
  // Handles option selection for each question

  const navigate = useNavigate();
  const {
    selectedPreviewFile,
    setSelectedPreviewFile,
    SetModulePreviewData,
    setFetchData
  } = useModulePreviewContext();
  const [isPreviewLoading, setIsPreviewloading] = React.useState(false);
  const [uiFields, setUiFields] = React.useState<any>();
  const [fieldsData, setFeildsData] = React.useState<any>();
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const section = query.get('section');
  const subSection = query.get('subsection');
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const fileId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
    const filetype=EncryptUtils.getDecryptedData(
      location?.search,
      BASE_UNIQUE_TYPE
    );
  const moduleId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_MODULE_ID
  );
  const previewId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_PREVIEW_ID
  );
  const subModuleName = EncryptUtils.getDecryptedData(
    location?.search,
    MOVE_TO_TAB
  );
  // console.log(
  //   'uniqueId',
  //   uniqueId,
  //   'fileId',
  //   fileId,
  //   'moduleId',
  //   moduleId,
  //   'previewId',
  //   previewId,
  //   'subModuleName',
  //   subModuleName
  // );
  // Detect tab switch
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        setTabSwitchDetected(true);
        const timer = setInterval(() => {
          setCountdown(prev => {
            if (prev === 1) {
              clearInterval(timer);
              // Handle test termination logic here
            }
            return prev - 1;
          });
        }, 1000);

        setTabTimer(timer); // ✅ Store the timer reference
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (tabTimer) clearInterval(tabTimer); // ✅ Clear interval safely
    };
  }, [tabTimer]);

  // Timer countdown
  const init = async () => {
    try {
      setIsloading(true);
      const res = await getSearchForm(
        applicationName,
        'module',
        'PreviewQuestions'
      );
      setUiFields(res.searchForm);
      if (res.searchForm) {
        let sqlName;
        const operations = 'SEARCH';
        let TableName;
        let TableQuestions;
        //console.log('subModuleName', subModuleName);
        switch (subModuleName) {
          case 'pre_learning_activities':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            sqlName = 'PreLearning_sql';
            break;
          case 'post_learning_activities':
            (TableName = 'SettingsPostLearningTestList'),
              (TableQuestions = 'SettingsPostLearningQuestionsStorage');
            sqlName = 'PostLearning_sql';
            break;
          case 'prepost_feedback':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            break;
          case 'ModuleMain':
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
          default:
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
        }
        if (sqlName) {
          const {sqldata} = res.searchForm[sqlName];

          const data: any = {
            sql_data: sqldata,
            data: {
              id: fileId,
              testId: previewId,
              ModuleTable: TableName,
              course_overview_id: uniqueId,
              QuestionsTable: TableQuestions,
              isAdmin: lmsisAdmin === 'True'
            },

            operation: operations
          };
          const encryptRequestData = EncryptUtils.encryptedData(data);
          const result = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });
          if (result.data[0]) {
            const transformedResult = result.data.map((item: any) => {
              return {
                ...item,
                // Parse JSON fields or set them to empty arrays if they are null
                choices: item.choices ? JSON.parse(item.choices) : null,
                correctMatches: item.correctMatches
                  ? JSON.parse(item.correctMatches)
                  : null,
                additionalChoices: item.additionalChoices
                  ? JSON.parse(item.additionalChoices)
                  : null,
                descriptive_enforce_word_limit:
                  item.descriptive_enforce_word_limit
                    ? JSON.parse(item.descriptive_enforce_word_limit)
                        .descriptive_enforce_word_limit
                    : null,
                // Parse the descriptive_enforce_word_limit_length JSON or set it to null
                descriptive_enforce_word_limit_length:
                  item.descriptive_enforce_word_limit_length
                    ? JSON.parse(item.descriptive_enforce_word_limit_length)
                        .descriptive_enforce_word_limit_length
                    : null,
                TrueFalse: item.TrueFalse
                  ? JSON.parse(item.TrueFalse).TrueFalse
                  : null
                // Add any additional transformations here if needed
              };
            });
            //console.log('transformedResult[0]', transformedResult[0]);
            setFeildsData(transformedResult[0]);
            if (transformedResult[0].TotalTimeInMinutes * 60) {
              setTimeLeft(transformedResult[0].TotalTimeInMinutes * 60);
            }
            if (transformedResult[0].overallTime_in_minutes) {
              setTimeLeft(transformedResult[0].overallTime_in_minutes * 60);
            }
            if (
              transformedResult[0].files &&
              transformedResult[0].files.length > 0 &&
              transformedResult[0].assessment_question_layout_type_id === 1
            ) {
              setFileSelected(transformedResult[0].files[0]);
              setSelectedOption(transformedResult[0].files[0].id);
            }
          }
        }
        setIsloading(false);
      }
      setIsloading(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      setIsloading(false);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      await init();
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (fieldsData) {
      const timer = setInterval(() => {
        setTimeLeft(prev => (prev > 0 ? prev - 1 : 0));
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [fieldsData]);

  useEffect(() => {
    const handleBackButton = (event: PopStateEvent) => {
      event.preventDefault();
      window.history.pushState(null, '', window.location.href);
      navigate(0); // Reload the page to enforce restriction
    };

    // Push initial state without adding duplicates
    if (window.history.state === null) {
      window.history.pushState(null, '', window.location.href);
    }

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);
  const handleCloseTabWarning = () => {
    setTabSwitchDetected(false);
    setCountdown(5);
  };

  const saveAnswerSubmit = async (updatedAnswers: any[], type?: string) => {
    try {
      let sqlName = '';
      switch (subModuleName) {
        case 'pre_learning_activities':
          sqlName = 'PreLearning_sql';
          break;
        case 'post_learning_activities':
          sqlName = 'PostLearning_sql';
          break;
        case 'prepost_feedback':
          break;
        case 'ModuleMain':
          sqlName = 'Module_sql';
          break;
        default:
          sqlName = 'Module_sql';
          break;
      }
      if (!uiFields || !uiFields[sqlName]) return;

      const {sqldata} = uiFields[sqlName];
      const operations = 'INSERT';
      //console.log('updatedAnswers', updatedAnswers);
      const data: any = {
        sql_data: sqldata,
        data: {
          testId: previewId,
          choices: updatedAnswers ? JSON.stringify(updatedAnswers) : null, // ✅ Send updated array instead of object
          additionalChoices: type,
          isAdmin: lmsisAdmin === 'True',
          course_overview_id: uniqueId
        },
        operation: operations
      };
      //console.log('data', data);
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const datavalue = await getLMSResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      await setFeildsData(datavalue?.data[0]);
      return datavalue?.data[0];
    } catch (error) {
      console.error('Error saving answer:', getErrorMessage(error));
      enqueueSnackbar('Failed to save answer', {
        variant: 'error',
        autoHideDuration: 5000
      });
    }
  };
  const saveAnswer = async (updatedAnswers: any[], type?: string) => {
    try {
      let sqlName = '';
      switch (subModuleName) {
        case 'pre_learning_activities':
          sqlName = 'PreLearning_sql';
          break;
        case 'post_learning_activities':
          sqlName = 'PostLearning_sql';
          break;
        case 'prepost_feedback':
          break;
        case 'ModuleMain':
          sqlName = 'Module_sql';
          break;
        default:
          sqlName = 'Module_sql';
          break;
      }
      if (!uiFields || !uiFields[sqlName]) return;

      const {sqldata} = uiFields[sqlName];
      const operations = 'INSERT';
      //console.log('updatedAnswers', updatedAnswers);
      const data: any = {
        sql_data: sqldata,
        data: {
          testId: previewId,
          choices: updatedAnswers ? JSON.stringify(updatedAnswers) : null, // ✅ Send updated array instead of object
          additionalChoices: type,
          isAdmin: lmsisAdmin === 'True',
          course_overview_id: uniqueId
        },
        operation: operations
      };
      //console.log('data', data);
      const encryptRequestData = EncryptUtils.encryptedData(data);
      await getLMSResultsData(applicationName, 'LMS', {tk: encryptRequestData});
    } catch (error) {
      console.error('Error saving answer:', getErrorMessage(error));
      enqueueSnackbar('Failed to save answer', {
        variant: 'error',
        autoHideDuration: 5000
      });
    }
  };

  const handleOptionChange = async (
    id: any,
    type: number,
    value: string | boolean
  ) => {
    try {
      setSelectedOptions(prevAnswers => {
        const existingIndex = prevAnswers.findIndex(q => q.id === id);
        let updatedAnswers = [...prevAnswers];

        switch (type) {
          case 1: // Single Choice Question
          case 3: // True/False Question
            if (existingIndex !== -1) {
              // ✅ If already answered, update it (or remove if deselected)
              if (updatedAnswers[existingIndex].answers === value) {
                updatedAnswers[existingIndex].answers = '';
                updatedAnswers[existingIndex].isanswered = false; // Deselect answer
              } else {
                updatedAnswers[existingIndex].answers = value; // Update answer
                updatedAnswers[existingIndex].isanswered = true;
              }
            } else {
              // ✅ If new question, add it to the array
              updatedAnswers = [
                ...prevAnswers,
                {id, type, isanswered: true, answers: value}
              ];
            }
            break;

          case 2: // Multiple Choice Question
            if (existingIndex !== -1) {
              let currentAnswers = updatedAnswers[existingIndex]
                .answers as string[];
              if (currentAnswers.includes(value as string)) {
                currentAnswers = currentAnswers.filter(ans => ans !== value);
              } else {
                currentAnswers.push(value as string);
              }
              updatedAnswers[existingIndex].answers = currentAnswers;
              if (currentAnswers.length > 0) {
                updatedAnswers[existingIndex].isanswered = true;
              } else {
                updatedAnswers[existingIndex].isanswered = false;
              }
            } else {
              updatedAnswers.push({
                id,
                type,
                isanswered: true,
                answers: [value as string]
              });
            }
            break;

          default:
            console.error('Unknown question type');
        }
        setTimeout(() => {
          saveAnswer(updatedAnswers);
        }, 0);
        return updatedAnswers;
      });
    } catch (error) {
      console.error('Error updating answer:', getErrorMessage(error));
      enqueueSnackbar('Failed to save answer', {
        variant: 'error',
        autoHideDuration: 5000
      });
    }
  };
  const handleMatchTheFollowingChange = (
    id: any,
    updatedAnswers: {left: string; right: string}[]
  ) => {
    setSelectedOptions(prevAnswers => {
      const existingIndex = prevAnswers.findIndex(q => q.id === id);
      const updated = [...prevAnswers];

      if (existingIndex !== -1) {
        updated[existingIndex].answers = updatedAnswers;
      } else {
        updated.push({id, type: 4, isanswered: true, answers: updatedAnswers});
      }

      saveAnswer(updated);
      return updated;
    });
  };

  const onRoleChange = async (data: any) => {
    // const value = await PreviewSaving();
    // console.log('valus', value);
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: uniqueId,
      [LMS_TYPE]: lmstype,
      [BASE_UNIQUE_ID]: fileId,
      [BASE_UNIQUE_TYPE]:filetype,
      [LMS_MODULE_ID]: moduleId,
      [LMS_PREVIEW_ID]: previewId,
      [MOVE_TO_TAB]: subModuleName,
      [LMS_IS_ADMIN]: lmsisAdmin
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/OnlineTest/Thankyou?${PARAMS_KEY}=${paramsKey}`,
      {
        state: {data}
      }
    );
  };
  const handleSubmit = async () => {
    try {
      setIsPreviewloading(true);

      if (!fieldsData || !fieldsData.files) {
        enqueueSnackbar('No questions available!', {
          variant: 'error',
          autoHideDuration: 5000
        });
        return;
      }

      // Ensure all questions are included in the payload
      const answersPayload = fieldsData.files.map(
        (question: {id: any; QuestionType_id: any}) => {
          const existingAnswer = selectedOptions.find(
            q => q.id === question.id
          );
          return {
            id: question.id,
            type: question.QuestionType_id,
            isanswered: existingAnswer ? existingAnswer.isanswered : false,
            answers: existingAnswer ? existingAnswer.answers : '' // If unanswered, store null
          };
        }
      );
      //console.log('fieldsData', fieldsData, answersPayload, selectedOptions);
      const value = await saveAnswerSubmit(answersPayload, 'SUBMIT');
      let updatedFileData: any | null = null;
      setFetchData({fileId:fileId,moduleId:moduleId,fetched:true});
      SetModulePreviewData((prevState: ModuleData[]) =>
        prevState.map(module => {
          const updatedFiles =
            module.files?.map(file => {
              const isTargetFile = file.id === fileId && module.id === moduleId;

              const updatedFile = {
                ...file,
                ChildItems_Completed: isTargetFile
                  ? true
                  : file?.ChildItems_Completed ?? false,

                ...(file.remainingAttempts !== undefined &&
                isTargetFile &&
                lmsisAdmin !== 'True'
                  ? {remainingAttempts: Math.max(file.remainingAttempts - 1, 0)}
                  : {})
              };

              // Capture the updated file separately
              if (isTargetFile) {
                updatedFileData = updatedFile;
              }

              return updatedFile;
            }) || [];

          const allFilesCompleted =
            updatedFiles.length > 0 &&
            updatedFiles.every(file => file.ChildItems_Completed);

          return {
            ...module,
            files: updatedFiles,
            Module_Completed: allFilesCompleted
          };
        })
      );

      // At this point, `updatedFileData` contains the modified file object
      // if (updatedFileData) {
      //   console.log('Updated file:', updatedFileData);
      //   // You can use updatedFileData in your component logic
      // }

      setSelectedPreviewFile(updatedFileData);
      setIsPreviewloading(false);

      enqueueSnackbar('Assessment submitted successfully!', {
        variant: 'success',
        autoHideDuration: 5000 // 2 seconds in milliseconds
      });
      onRoleChange(value);
    } catch (error) {
      console.error('Error submitting assessment:', getErrorMessage(error));
      setIsPreviewloading(false);

      enqueueSnackbar('Failed to submit assessment', {
        variant: 'error',
        autoHideDuration: 5000
      });
    }
  };

  useEffect(() => {
    if (
      timeLeft === 0 &&
      (fieldsData?.TotalTimeInMinutes || fieldsData?.overallTime_in_minutes)
    ) {
      // Use a function to prevent unnecessary re-execution
      const handleTimeEnd = async () => {
        await handleSubmit(); // Submit after role change
        // await onRoleChange(); // Ensure this does not cause state update loops
      };

      handleTimeEnd();
    }
    if(countdown===0){
      const handleTimeEnd = async () => {
        await handleSubmit(); // Submit after role change
        // await onRoleChange(); // Ensure this does not cause state update loops
      };

      handleTimeEnd();
    }
  }, [timeLeft, fieldsData, onRoleChange, handleSubmit,countdown]); // ✅ Added missing dependencies

  const formatTime = (time: any) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };
  const FetchQuestion = (question: any) => {
    switch (question.QuestionType_id) {
      case 1: // Single Option
        return (
          <RadioGroup
            value={
              selectedOptions.find(q => q.id === question.id)?.answers || ''
            }
            sx={{mt: 2}}>
            {question.choices.map(
              (option: {id: any; OptionText: string}) => (
                <FormControlLabel
                  key={option.id}
                  value={option.id.toString()}
                  control={
                    <Radio
                      onClick={() =>
                        handleOptionChange(
                          question.id,
                          question.QuestionType_id,
                          option.id.toString()
                        )
                      }
                    />
                  }
                  label={option.OptionText}
                />
              )
            )}
          </RadioGroup>
        );

      case 2: // Multiple Choice
        return (
          <FormGroup sx={{mt: 2}}>
            {question.choices.map(
              (option: {id: any; OptionText: string}) => {
                const selected =
                  (selectedOptions.find(q => q.id === question.id)
                    ?.answers as string[]) || [];
                return (
                  <FormControlLabel
                    key={option.id}
                    control={
                      <Checkbox
                        checked={selected.includes(option.id.toString())}
                        onChange={() =>
                          handleOptionChange(
                            question.id,
                            question.QuestionType_id,
                            option.id.toString()
                          )
                        }
                      />
                    }
                    label={option.OptionText}
                  />
                );
              }
            )}
          </FormGroup>
        );

      case 3: // True/False
        return (
          <RadioGroup
            value={
              selectedOptions.find(q => q.id === question.id)?.answers || ''
            }
            sx={{mt: 2}}>
            {[
              {id: 1, OptionText: 'True'},
              {id: 0, OptionText: 'False'}
            ].map((option: {id: any; OptionText: string}) => (
              <FormControlLabel
                key={option.id}
                value={option.id.toString()}
                control={
                  <Radio
                    onClick={() =>
                      handleOptionChange(
                        question.id,
                        question.QuestionType_id,
                        option.id.toString()
                      )
                    }
                  />
                }
                label={option.OptionText}
              />
            ))}
          </RadioGroup>
        );

      case 4: // Match the Following
        const selected =
          (selectedOptions.find(q => q.id === question.id)
            ?.answers as string[]) || [];
        return (
          <MatchTheFollowingQuestion
            layout={fieldsData?.assessment_question_layout_type_id}
            question={question}
            selectedAnswers={selected}
            onAnswerChange={(questionId: any, updatedAnswers) => {
              setSelectedOptions(prev => {
                const existingIndex = prev.findIndex(q => q.id === questionId);
                const updated = [...prev];

                if (existingIndex !== -1) {
                  updated[existingIndex].answers = updatedAnswers;
                } else {
                  updated.push({
                    id: questionId,
                    type: 4,
                    isanswered: true,
                    answers: updatedAnswers
                  });
                }
                //console.log('updates', updated);
                saveAnswer(updated);
                return updated;
              });
            }}
          />
        );
      case 5:
        return (
          <ContextTextField
            key={question.id}
            question={question}
            value={
              selectedOptions[
                selectedOptions.findIndex(q => q.id === question.id)
              ]?.answers
                ? String(
                    selectedOptions[
                      selectedOptions.findIndex(q => q.id === question.id)
                    ]?.answers
                  )
                : ''
            }
            setErrors={setError}
            onAnswerChange={(questionId, updatedAnswers) => {
              setSelectedOptions(prev => {
                const existingIndex = prev.findIndex(q => q.id === questionId);
                const updated = [...prev];
                // console.log(
                //   'updatedAnswers',
                //   questionId,
                //   updatedAnswers,
                //   existingIndex
                // );
                if (existingIndex !== -1) {
                  if (updatedAnswers === '' || updatedAnswers === null) {
                    // console.log('entesrs');
                    updated[existingIndex].answers = updatedAnswers;
                    updated[existingIndex].isanswered = false;
                  } else {
                    updated[existingIndex].isanswered = true;
                    updated[existingIndex].answers = updatedAnswers;
                  }
                } else {
                  if (updatedAnswers === '' || updatedAnswers === null) {
                    updated.push({
                      id: questionId,
                      type: 5,
                      isanswered: false,
                      answers: updatedAnswers
                    });
                  } else {
                    updated.push({
                      id: questionId,
                      type: 5,
                      isanswered: true,
                      answers: updatedAnswers
                    });
                  }
                }
                // console.log('updates', updated);
                // saveAnswer(updated);
                return updated;
              });
            }}
          />
        );

      default:
        return null;
    }
  };
  const renderContent = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1
      }}>
      <Logo
        disabledLink={true}
        applicationName={'LMS'}
        sx={{mt: 3, ml: 4, mb: 1}}
      />

              {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED  &&<AccountPopover isDashboard={true} /> }
    </Box>
  );
  return (
    <Box
      sx={{
        background: 'linear-gradient(to right, #3a7bd5, #3a6073)',
        color: 'white'
      }}>
      <Toolbar
        sx={{
          height: 1,
          backgroundColor: 'white'
          // px: {lg: 5}
        }}>
        {renderContent}
      </Toolbar>
      {isLoading ? (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'91vh'}>
          <LoadingScreen />
        </Stack>
      ) : (
        <Box sx={{py: 4, minHeight: '91vh', overflowY: 'auto'}}>
          {/* Header */}
          <Box>
            <Typography
              variant="h5"
              sx={{
                textAlign: 'center',
                fontWeight: 'bold',
                mb: 0.5
              }}>
              {fieldsData?.name}
            </Typography>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{mb: 1, display: 'flex'}}
              justifyContent={'center'}>
              <Grid item sx={{display: 'flex'}}>
                <Typography variant="subtitle2" sx={{mr: 0.5}}>
                  <strong>Date : </strong>
                </Typography>
                <Typography variant="body1">
                  {fieldsData?.testStartTime
                    ? new Date(fieldsData.testStartTime).toLocaleDateString(
                        'en-GB',
                        {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        }
                      )
                    : 'N/A'}
                </Typography>
              </Grid>
              {/* Dynamically Render Fields */}
              {[
                {
                  label: 'Total Questions : ',
                  value: fieldsData?.TotalQuestions
                },
                {label: 'Total Marks : ', value: fieldsData?.TotalMarks}
              ]
                .filter(
                  field => field.value !== undefined && field.value !== null
                ) // Ensure only valid fields are shown
                .map((field, index) => (
                  <Grid key={index} item sx={{display: 'flex'}}>
                    <Typography variant="subtitle2" sx={{mr: 0.5}}>
                      <strong>{field.label}</strong>
                    </Typography>
                    <Typography variant="body1">{field.value}</Typography>
                  </Grid>
                ))}

              {/* Action Button */}
            </Grid>
          </Box>

          {/* Main Exam Layout */}
          <Box>
            <Grid
              container
              spacing={3}
              sx={{flexDirection: {sm: 'row', md: 'row-reverse'}}}
              justifyContent="center">
              {/* Question Panel */}
              <Grid item sm={10} xs={10} md={3}>
                <Card sx={{borderRadius: '10px'}}>
                  <CardContent>
                    <Typography variant="subtitle1" sx={{fontWeight: 'bold'}}>
                      {fieldsData?.TotalTimeInMinutes ||
                      fieldsData?.overallTime_in_minutes
                        ? `Total Duration: ${fieldsData?.TotalTimeInMinutes || fieldsData?.overallTime_in_minutes} Minutes`
                        : `Total Duration: infinite`}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Assessment ends in
                    </Typography>

                    {/* Timer Circle */}
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'center',
                        my: 2
                      }}>
                      <CircularProgress
                        variant="determinate"
                        value={
                          (timeLeft /
                            ((fieldsData?.TotalTimeInMinutes ||
                              fieldsData?.overallTime_in_minutes) *
                              60)) *
                          100
                        }
                        size={80}
                        thickness={5}
                        color="error"
                      />
                      <Typography
                        variant="body1"
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          fontWeight: 'bold'
                        }}>
                        {formatTime(timeLeft)}
                      </Typography>
                    </Box>

                    {/* Answer Status */}
                    <Typography variant="h3">
                      {`${selectedOptions?.filter(q => q.answers !== '').length}/${fieldsData?.files.length}`}
                      Answered
                    </Typography>

                    <Box
                      sx={{
                        display: 'content',
                        justifyContent: 'center',
                        m: 0.5
                      }}>
                      {fieldsData?.files.map(
                        (question: {id: any}, index: any) => {
                          const isAnswered = selectedOptions?.some(
                            q => q.id === question.id && q.isanswered
                          );
                          // console.log('isAnswered', isAnswered);
                          return (
                            <Button
                              key={question.id}
                              variant="outlined"
                              sx={{
                                mx: 1,
                                minWidth: 30,
                                backgroundColor: isAnswered
                                  ? '#93ec9aa3'
                                  : question.id === selectedOption
                                    ? '#9cc4e8'
                                    : 'transparent', // ✅ Green background if answered
                                borderColor: isAnswered
                                  ? '#2c8030'
                                  : question.id === selectedOption
                                    ? '#0f0f7387'
                                    : 'rgba(0, 0, 0, 0.23)', // ✅ Green border if answered
                                color: isAnswered
                                  ? '#18531b'
                                  : question.id === selectedOption
                                    ? '#3157de'
                                    : 'inherit' // ✅ Dark green text if answered
                              }}
                              onClick={() => {
                                if (
                                  fieldsData?.assessment_question_layout_type_id ===
                                  1
                                ) {
                                  const questionIndex =
                                    fieldsData?.files.findIndex(
                                      (q: {id: any}) =>
                                        q.id === question.id
                                    );
                                  setSelectedOption(question.id);
                                  setFileSelected(
                                    fieldsData?.files[questionIndex]
                                  );
                                }
                              }}>
                              {index + 1}
                            </Button>
                          );
                        }
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              <Grid
                item
                sx={{display: 'flex', flexDirection: 'column', rowGap: 2}}
                xs={10}
                sm={10}
                md={8}>
                {fieldsData?.assessment_question_layout_type_id === 1 &&
                  fileSelected && (
                    <Card
                      key={fileSelected.id}
                      sx={{borderRadius: '10px', flex: 1}}>
                      <CardContent>
                        {/* Question Numbering */}
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'baseline',
                            columnGap: 2
                          }}>
                          <Typography variant="h6">
                            {/* <strong>{index + 1}</strong> /{' '} */}
                            {fieldsData?.files.findIndex(
                              (q: {id: any}) =>
                                q.id === fileSelected.id
                            ) + 1}
                          </Typography>

                          {/* Question Text */}
                          <Typography variant="h5" sx={{mt: 1}}>
                            <strong>{fileSelected.QuestionText}</strong>
                          </Typography>
                        </Box>
                        {FetchQuestion(fileSelected)}
                      </CardContent>
                    </Card>
                  )}
                {fieldsData?.assessment_question_layout_type_id === 2 &&
                  fieldsData?.files?.map(
                    (
                      question: {
                        id: any;
                        QuestionText: string;
                        QuestionType_id: any;
                        choices: any[];
                      },
                      index: any
                    ) => (
                      <Card key={question.id} sx={{borderRadius: '10px'}}>
                        <CardContent>
                          {/* Question Numbering */}
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'baseline',
                              columnGap: 2
                            }}>
                            <Typography variant="h6">
                              <strong>{index + 1}</strong> /{' '}
                              {fieldsData?.files.length}
                            </Typography>

                            {/* Question Text */}
                            <Typography variant="h5" sx={{mt: 1}}>
                              <strong>{question.QuestionText}</strong>
                            </Typography>
                          </Box>
                          {FetchQuestion(question)}
                          {/* Options (Radio Group for Single Choice Questions) */}
                          {/* {question.choices && (
                        <RadioGroup
                          value={
                            selectedOptions.find(q => q.id === question.id)
                              ?.answer || ''
                          }
                          sx={{mt: 2}}>
                          {question.choices.map(
                            (option: {id: any; OptionText: string}) => (
                              <FormControlLabel
                                key={option.id}
                                value={option.id.toString()}
                                control={
                                  <Radio
                                    onClick={() =>
                                      handleOptionChange(
                                        question.id,
                                        question.QuestionType_id,
                                        option.id.toString()
                                      )
                                    }
                                  />
                                }
                                label={option.OptionText}
                              />
                            )
                          )}
                        </RadioGroup>
                      )} */}
                        </CardContent>
                      </Card>
                    )
                  )}

                <Box sx={{display: 'flex', columnGap: 2}}>
                  {fieldsData?.assessment_question_layout_type_id === 1 &&
                    fieldsData?.files.findIndex(
                      (q: {id: any}) => q.id === fileSelected.id
                    ) +
                      1 <
                      fieldsData?.files.length && (
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={isPreviewLoading}
                        color="info"
                        onClick={() => {
                          if (!error) {
                            const questionIndex = fieldsData?.files.findIndex(
                              (q: {id: any}) =>
                                q.id === selectedOption
                            );
                            setSelectedOption(
                              fieldsData?.files[questionIndex + 1].id
                            );
                            setFileSelected(
                              fieldsData?.files[questionIndex + 1]
                            );
                          }
                        }}>
                        Next
                      </Button>
                    )}
                  <LoadingButton
                    type="submit"
                    loading={isPreviewLoading}
                    variant="contained"
                    color="success"
                    onClick={() => {
                      if (!error) {
                        setOpen(true);
                      }
                    }}>
                    Submit Assessment
                  </LoadingButton>
                </Box>
              </Grid>

              {/* Timer & Question Navigation */}
            </Grid>
            {/* {fieldsData?.assessment_question_layout_type_id === 2 && (
              <Grid container sx={{mt: 2, ml: 2}}>
                <LoadingButton
                  type="submit"
                  loading={isPreviewLoading}
                  variant="contained"
                  color="info"
                  onClick={() => setOpen(true)}>
                  Submit Assessment
                </LoadingButton>
              </Grid>
            )} */}
          </Box>
          {/* Tab Switching Warning Dialog */}
          <Dialog open={tabSwitchDetected} maxWidth="xs" fullWidth>
            <DialogTitle
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              <InfoIcon sx={{fontSize: '30px', color: 'orange', mr: 1}} />
              Tab Switching Detected
            </DialogTitle>
            <DialogContent>
              <Typography variant="body2" textAlign="center">
                Tab switching is restricted, attempt will be terminated in{' '}
                <strong>{countdown} seconds</strong>
              </Typography>
              <Typography variant="body2" textAlign="center" sx={{mt: 1}}>
                Cancel to resume test.
              </Typography>
            </DialogContent>
            <DialogActions sx={{justifyContent: 'center'}}>
              <Button variant="outlined" onClick={handleCloseTabWarning}>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          {open && (
            <ReviewAttemptDialog
              open={open}
              onClose={() => setOpen(false)}
              isPreviewLoading={isPreviewLoading}
              questions={selectedOptions}
              questionsPassed={fieldsData?.files}
              handleSave={async () => {
                await handleSubmit();
                setOpen(false);
                // onRoleChange();
              }}
            />
          )}
        </Box>
      )}
    </Box>
  );
};

export default ExamPage;

